<template>
  <div>
    <div
      class="anz-fc-alert anz-fc-alert-error anz-mb-s anz-my-xl anz-px-m anz-py-s"
    >
      <span class="anz-fc-alert-msg">
        {{ $translate('error.' + appError.message) }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import useAppState from '@/composables/ui/ui'

export default defineComponent({
  name: 'ErrorPage',
  setup() {
    return {
      ...useAppState(),
    }
  },
})
</script>
